// Generic imports
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

function migrateFormFromPriceQuoteToOpportunity({ form }) {
    const f = _.cloneDeep(form);
    delete f.currencies;
    f.sections.forEach(section => {

        const sectionType = section.type;
        delete section.type;

        section.fields.forEach(field => {
            if ((sectionType === 'peritem') && (field.type === 'number') && (field.postfix === '[currency]')) {
                field.type = 'per-unit';
            } else if ((sectionType === 'peritem') && (field.type === 'number') && (field.postfix === '[currency] per chargeable weight')) {
                field.type = 'per-unit-type';
            } else if ((sectionType === 'peritem') && (field.type === 'number') && (field.postfix === '[currency] per day')) {
                field.type = 'per-unit-type';
            } else if ((sectionType === 'general') && (field.type === 'number') && (field.postfix === 'days')) {
                field.type = 'per-unit-type';
            } else if ((sectionType === 'peritem') && (field.type === 'number') && (field.postfix === 'days')) {
                field.type = 'per-unit-type';
            } else if ((sectionType === 'general') && (field.type === 'number') && (field.postfix === '[currency]')) {
                field.type = 'flat';
            } else if ((sectionType === 'general') && (field.type === 'multiline')) {
                field.type = 'string';
            } else if ((sectionType === 'peritem') && (field.type === 'multiline')) {
                field.type = 'string';
            } else if ((sectionType === 'general') && (field.type === 'text')) {
                field.type = 'string';
            } else if ((sectionType === 'peritem') && (field.type === 'text')) {
                field.type = 'string';
            } else {
                console.log(sectionType, field);
                throw 'Error migrating form.';
            }

            field.id = uuidv4();
            delete field.postfix;
            delete field.variable;
            delete field.variables;
        })
    });
    f.type = (f.type === 'supplier' ? 'rate' : 'opportunity');
    return f;
}

export { migrateFormFromPriceQuoteToOpportunity };
